import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { StatisticsState } from './types';
import axios from '@/interceptor';
import { parkinglot } from '@/models/api-path.model';
import { defaultLists, defaultParameters, defaultStatistics } from '.';

declare const scrolling: Function;

export const actions: ActionTree<StatisticsState, RootState> = {
  /**
   * @param { commit }: actions에서는 mutations를 fetch하기 위한 commit method를 참조로서 제공한다.
   * @param payload: 참조된 commit method 다음부터는 인수를 받을 수 있다.
   */
  fetchSearchDetail({ commit }, payload): void {
    commit('setSearchDetail', payload);
  },
  /**
   * @method fetchSearchWord
   * @description 검색어 입력
   */
  fetchSearchWord({ commit }, payload): void {
    commit('setSearchWord', payload);
  },
  /**
   * @method fetchSearchCategory
   * @description 검색 구분값 입력
   */
  fetchSearchCategory({ commit }, payload): void {
    commit('setSearchCategory', payload);
  },
  
  /**
   * @method fetchSort
   * @description 정렬 입력
   */
  fetchSort({ commit }, payload): void { //void 메서드 리턴값이 없는 경우에 사용
    commit('setSort', payload);
  },

  /**
   * @method fetchStatistics
   * @description 통계 정보 호출
   */
  fetchStatistics({ commit, dispatch, state }): void {
    const parameters = Object.assign({}, state.parameters, { sort: null }) 
    parameters['searchCategory'] = (parameters['searchCategory'])? decodeURI(parameters['searchCategory']) : (parameters['searchCategory'])
    axios.get(parkinglot.statistics, { params: parameters })
      .then(resp => {
        const { code, message, result, error } = resp.data;

        if (error) {
          dispatch('dialog/showAlert', { message: message }, { root: true });
          return;
        }

        if (code !== 20000) {
          dispatch('dialog/showAlert', { message: message }, { root: true });
          return;
        }
        
        commit('setStatistics', result);
      })
      .catch(error => dispatch('dialog/showAlert', { message: error }, { root: true }))
  },
  /**
   * @method fetchStatisticsList
   * @description 주차장 목록 호출
   */
  fetchStatisticsList({ commit, dispatch, state }): void {
    axios.get(parkinglot.statisticsList, { params: Object.assign({}, state.parameters, state.list.paging) })
      .then(resp => {
        const { code, message, result, error } = resp.data;
        
        if (error) {
          dispatch('dialog/showAlert', { message: message }, { root: true });
          return;
        }

        if (code !== 20000) {
          dispatch('dialog/showAlert', { message: message }, { root: true });
          return;
        }
        
        if (result.parkingLotStatisticsListDtoList.length > 0) {
          const currentList = JSON.parse(JSON.stringify(state.list.parkingLotStatisticsListDtoList));
          const setResult = state.scrollOptions.scrollBind ?
            {
              paging: result.paging,
              parkingLotStatisticsListDtoList: currentList.concat(result.parkingLotStatisticsListDtoList)
            } :
            result;
          
          commit('setStatisticsList', setResult);
          dispatch('bindScrollEvent');
        }
      })
      .catch(error => dispatch('dialog/showAlert', { message: error }, { root: true }))
  },
  /**
   * @method fetchPagingOffset
   * @description 페이징 정보 입력
   */
  fetchPagingOffset({ commit }, payload): void {
    commit('setPagingOffset', payload);
  },
  /**
   * @method fetchScrollBind
   * @description 스크롤 이벤트 콜백 여부
   */
  fetchScrollBind({ commit }, payload): void {
    commit('setScrollBind', payload);
  },
  /**
   * @method fetchAllClear
   * @description 모든 state 초기화
   */
  fetchAllClear({ commit, dispatch }): void {
    commit('setSearchDetail', defaultParameters());
    commit('setSearchCategory', '등록자명');
    dispatch('fetchSearchWord', '');
    commit('setStatisticsList', defaultLists());
    commit('setStatistics', defaultStatistics());
  },
  handleScroll({ dispatch, state }): void {
    const target: HTMLElement = document.documentElement;
    const scrollTop: number  = target.scrollTop;
    const scrollHeight: number = target.scrollHeight;
    const clientHeight: number = target.clientHeight;
    const scrolling: number = scrollTop + clientHeight;

    if (scrolling >= scrollHeight - 50) {
      dispatch('fetchPagingOffset', state.list.paging.offset + state.list.paging.limit);
      dispatch('fetchScrollBind', true);
      dispatch('bindScrollEvent');
      dispatch('fetchStatisticsList');
    }
  },
  bindScrollEvent({ dispatch, state }): void {
    state.scrollOptions.callbackFn = () => {
      dispatch('handleScroll');
    }

    setTimeout(() => {
      window.removeEventListener('scroll', <any>state.scrollOptions.callbackFn);
      window.addEventListener('scroll', <any>state.scrollOptions.callbackFn);
    }, 1000)
    
  },
  unbindScrollEvent({ state }): void {
    window.removeEventListener('scroll', <any>state.scrollOptions.callbackFn);
  }
}; //호출은 여기서 함 
